// @flow
import SearchAutoComplete from './SearchAutoComplete';

export default SearchAutoComplete;



// WEBPACK FOOTER //
// ./src/components/search/SearchAutoComplete/index.js